import { cn, Col } from '@rematter/ui-web';

export type SettingsContentProps = {
  children: React.ReactNode;
  className?: string;
  size?: 'small' | 'medium' | 'large' | 'full';
};

export const SettingsContent = ({
  children,
  className,
  size,
}: SettingsContentProps) => (
  <Col
    className={cn(
      '@SettingsContent mx-auto w-full max-w-[1150px]',
      size === 'small' && 'max-w-[800px]',
      size === 'medium' && 'max-w-[1024px]',
      size === 'full' && 'max-w-none',
      className,
    )}
  >
    {children}
  </Col>
);
